import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

const DivisionDetailMain = () => {
  const { t } = useTranslation();
  const {watch} = useFormContext();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <NFLookupDivision fieldName={"parentDivisionId"} title={t("ParentDivision")} companyId={watch('companyId')}/>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
      </Row>
    </>
  );
};

export default DivisionDetailMain;
